/**
 * 描述：租户管理--所有用户
 * 日期：2017-9-27
 * 作者：liu_jinming
 */
'use strict';
angular.module("allocationOfficialsModule", ['tManageMentServiceModule', 'checkNameRepeatedModule'])
    .controller("allocationOfficialsCtrl", ["$scope", "trsspliceString", "$q", "$filter", "tManageMentService", "modalDialog", "trsHttpService",
        function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService) {
            initStatus();
            initData();
            /** [initStatus description: 初始化状态] */
            function initStatus() {
                $scope.status = {
                    searchWord: '',
                    leaderList: [],
                };
                $scope.data = {
                    copyCurrPage: 1,
                    selectedLeader: [],
                };
                $scope.page = {
                    PAGESIZE: 10,
                    ITEMCOUNT: 　0,
                    CURRPAGE: 1,
                    PAGECOUNT: 1
                };
            }
            /** [initData description: 初始化数据] */
            function initData() {
                requestData();
            }
            /** [requestData description: 获取国家领导人的信息] */
            function requestData() {
                var params = {
                    "serviceid": "mlf_tenant",
                    "methodName": "queryCountryLeaderInfos",
                    "Page_NO": $scope.page.CURRPAGE,
                    "Page_Size": $scope.page.PAGESIZE
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.status.leaderList = [];
                    for (var i = 0; i < data.length - 1; i++) {
                        $scope.status.leaderList.push(data[i]);
                    }
                    $scope.page.PAGECOUNT = data[data.length - 1].PAGECOUNT;
                    $scope.page.ITEMCOUNT = data[data.length - 1].TOTALNUMBERS;
                });
            }
            /** [requestData description]当分页发生变化时相求请求相应的数据 */
            $scope.requestData = function() {
                requestData();
            };
            $scope.jumpToPage = function() {
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };
            /** [editTenantOff description: 编辑官员功能的] */
            $scope.editTenantOff = function(item) {
                tManageMentService.regionalOfficia(item).then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType("", "修改成功!", "success", false);
                        requestData();
                    } else {
                        modalDialog.alertType("", "修改失败!", "error", false);
                    }
                });
            };
            /** [selectAll description:全选radio选择框] */
            $scope.selectAll = function() {
                if ($scope.data.selectedLeader.length === $scope.status.leaderList.length && $scope.status.leaderList.length > 0) {
                    $scope.data.selectedLeader = [];
                } else {
                    $scope.data.selectedLeader = [];
                    for (var i = 0; i < $scope.status.leaderList.length; i++) {
                        $scope.data.selectedLeader.push($scope.status.leaderList[i].TENANTRELEVANTINFOID);
                    }
                }
            };
            /** [selectLeader description:选中领导数据的编号] */
            $scope.selectLeader = function(item) {
                if ($scope.data.selectedLeader.indexOf(item.TENANTRELEVANTINFOID) > -1) {
                    $scope.data.selectedLeader.splice($scope.data.selectedLeader.indexOf(item.TENANTRELEVANTINFOID), 1);
                } else {
                    $scope.data.selectedLeader.push(item.TENANTRELEVANTINFOID);
                }
            };
            /** [createNewLeader description: 新建领导人信息] */
            $scope.createNewLeader = function() {
                tManageMentService.regionalOfficia().then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType("", "保存成功!", "success", false);
                        requestData();
                    } else {
                        modalDialog.alertType("", "保存失败!", "error", false);
                    }
                });
            };
            /** [leaderDelete description: 批量删除领导信息] */
            $scope.leaderDelete = function() {
                modalDialog.alertType("", "确认删除?", "ask", true, function() {
                    leaderDeleteAll();
                });
            };
            /** [leaderDeleteAll description:批量删除选中的领导人信息 ] */
            function leaderDeleteAll() {
                var str = $scope.data.selectedLeader.join(",");
                var leaderDelete = {
                    "serviceid": "mlf_tenant",
                    "methodName": "delallTenantRelevantInfo",
                    "ObjectIds": str
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), leaderDelete, 'post').then(function() {
                    modalDialog.alertType("", "删除成功", 'success', false);
                    requestData();
                });
            }
            /** [leaderSreach description:检索领导人] */
            $scope.leaderSreach = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    var leaderSParams = {
                        "serviceid": "mlf_tenant",
                        "methodName": "queryCountryLeaderInfos",
                        "SearchField": $scope.status.searchWord
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), leaderSParams, 'post').then(function(data) {
                        $scope.status.leaderList = [];
                        for (var i = 0; i < data.length - 1; i++) {
                            $scope.status.leaderList.push(data[i]);
                        }
                    });
                }
            };
            /**删除单个的领导数据*/
            $scope.singleDelete = function(item) {
                modalDialog.alertType("", "确认删除？", "ask", true, function() {
                    singleDeleteDetail(item);
                }, function() {

                });
            };
            /** [singleDeleteDetail description: 在确认删除执行的删除操作] */
            function singleDeleteDetail(item) {
                var singleParams = {
                    "serviceid": "mlf_tenant",
                    "methodName": "delallTenantRelevantInfo",
                    "ObjectIds": item.TENANTRELEVANTINFOID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), singleParams, 'post').then(function(data) {
                    if (data.TYPE == '3') {
                        modalDialog.alertType("", "删除成功!", 'success', false);
                        requestData();
                    } else {
                        modalDialog.alertType("", "删除失败!", 'error', false);
                    }

                });
            }
        }
    ]);